import { palette } from "../theme";

export const statusLabelMap: Record<string, string> = {
  NEW: "New",
  IN_PROGRESS: "In Progress",
  STANDBY: "Standby",
  DELAYED: "Delayed",
  IN_REVIEW: "In Review",
  DONE: "Done",
};

export const statusColorMap: Record<string, string> = {
  NEW: "blue",
  IN_PROGRESS: "orange",
  STANDBY: "red",
  DELAYED: "volcano",
  IN_REVIEW: "purple",
  DONE: "green",
};

export const priorityLabelMap: Record<string, string> = {
  H: "↑ High",
  M: "→ Medium",
  L: "↓ Low",
};

export const priorityColoMap: Record<string, string> = {
  H: palette.priorityHigh,
  M: palette.priorityMedium,
  L: palette.priorityLow,
};

export const resolutionLabelMap: Record<string, string> = {
  APPROVED: "Approved",
  REJECTED: "Rejected",
};

export const resolutionColorMap: Record<string, string> = {
  APPROVED: "green",
  REJECTED: "red",
};

export const standbyReasonLabelMap: Record<string, string> = {
  WEATHER: "Weather",
  LOGISTICS: "Logistics",
  TECHNICAL: "Technical",
  SAFETY: "Safety",
};

export const measurementUnitLabelMap: Record<string, string> = {
  KG: "kg",
  G: "g",
  L: "L",
  ML: "ml",
  M2: "m²",
  EACH: "each",
};

export const measurementUnitOptions = Object.entries(measurementUnitLabelMap).map(
  ([value, label]) => ({ value, label })
);
